/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import { toast } from 'react-toastify'; //토스트(toast)
import { confirmAlert } from 'react-confirm-alert'; //알럿창(alert confirm)
// import InfiniteScroll from "react-infinite-scroll-component";
// import ContentItem from "../../components/ContentItem";

class MyMemberShip extends Component {
  state = {
    gotoPage: 1,
    pageCount: 1,
    pageSize: 10,
    dataList: [],
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    this._getData(1);
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _getData = async (gotoPage) => {
    const { loginId } = this.props;

    if (loginId === null || loginId === undefined || loginId === '') {
    } else {
      const result = await this._getDataApi(gotoPage);
      const intReturn = result.data[0].intReturn;
      const pageCount = result.data[0].pageCount;
      const con = result.data[0].con;
      const auto = result.data[0].auto;
      //const cash = result.data[0].cash;
      const dataList = result.data[0].listData;
      //console.log(con)

      if (this._isMounted) {
        if (intReturn === 0) {
          if (con > 0) {
            //console.log('con > 0')
            this.setState({
              gotoPage: gotoPage,
              pageCount: pageCount,
              con: con,
              auto: auto,
              //cash: cash,
              dataList: dataList,
              hasMore: pageCount < gotoPage ? false : true,
            });
          } else {
            //console.log('con < 0')
            this.setState({
              gotoPage: 1,
              pageCount: 1,
              con: con,
              auto: auto,
              //cash: cash,
              dataList: [],
              hasMore: pageCount < gotoPage ? false : true,
            });
          }
        } else {
          //console.log('intReturn <> 0')
          this.setState({
            gotoPage: 1,
            pageCount: 1,
            con: con,
            auto: auto,
            //cash: cash,
            dataList: [],
            hasMore: pageCount < gotoPage ? false : true,
          });
        }
      }
    }
  };
  _getDataApi = (gotoPage) => {
    const { apiUrl, loginId, authId } = this.props;

    return axios
      .post(apiUrl + '/myMembership', {
        params: {
          userid: loginId,
          authId: authId,
          gotoPage: gotoPage,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };
  _expire = () => {
    confirmAlert({
      title: '정기결제 해지',
      message:
        '현재 이용중인 정기결제를 해지하시겠습니까? 멤버십 이용기간 까지 사용이 가능하며 종료일 이후 더이상 결제가 되지 않습니다. (해지일로 부터 30일동안 재 가입이 제한됩니다.)',
      buttons: [
        {
          label: '정기결제 해지',
          onClick: () => {
            this._onExpire();
          },
        },

        {
          label: '취소',
          //onClick: () => alert('Click No')
        },
      ],
    });
  };
  _onExpire = async () => {
    const { loginId } = this.props;
    if (loginId === null || loginId === undefined || loginId === '') {
      toast.warn('로그인 후 이용해 주세요');
    } else {
      const result = await this._onExpireApi();
      if (result) {
        const intReturn = result.data[0].intReturn;

        if (intReturn === 0) {
          toast.success('정기결제가 정상적으로 해지 되었습니다. 감사합니다.');
          this._getData(1);
        } else if (intReturn === -2) {
          toast.error('해지할 정기결제가 존재하지 않습니다.');
        } else if (intReturn === -1) {
          toast.error('회원정보가 존재하지 않습니다.');
        }
      }
    }
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };
  _onExpireApi = () => {
    const { apiUrl, loginId, authId, history } = this.props;
    const at = this.getCookie('at');
    // const at = localStorage.getItem('at');

    return axios
      .post(
        apiUrl + '/myMembershipExpire',
        {
          params: {
            userid: loginId,
            authId: authId,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken();
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _refreshToken = async () => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');
    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      this._onExpire();
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  _renderPage = () => {
    const { pageCount, gotoPage } = this.state;
    const pageNumbers = [];
    let blockPage = ((gotoPage - 1) / 10) * 10 + 1;
    let i = 0;
    ////console.log(blockPage, pageCount)
    do {
      pageNumbers.push(i);
      blockPage = blockPage + 1;
      i = i + 1;
    } while (i < 10 && i < pageCount);
    ////console.log(pageNumbers)
    const list = pageNumbers.map((num, index) => {
      return (
        <span
          key={index}
          style={{ cursor: 'pointer' }}
          onClick={() => this._getData(num + 1)}
          className={gotoPage === num + 1 ? 'on' : null}
        >
          {num + 1}
        </span>
      );
    });

    return list;
  };
  _onPrev = () => {
    const { gotoPage } = this.state;

    if (gotoPage === 1) {
      //alert('페이지의 처음입니다.')
      toast.warn('페이지의 처음입니다.');
    } else {
      this._getData(gotoPage - 1);
    }
  };
  _onNext = () => {
    const { gotoPage, pageCount } = this.state;
    if (gotoPage + 1 >= pageCount) {
      toast.warn('페이지의 마지막입니다.');
      //alert('페이지의 마지막입니다.')
    } else {
      this._getData(gotoPage + 1);
    }
  };
  _renderItem = () => {
    const { dataList } = this.state;
    const list = dataList.map((item, index) => {
      return (
        <tr key={index}>
          <td>{item.regDate}</td>
          <td>
            {item.freepassName === '' ||
            item.freepassName === null ||
            item.freepassName === undefined
              ? '기타'
              : item.freepassName}{' '}
            {item.autoFlag === 'A' ? '(정기결제)' : null}{' '}
          </td>
          <td>
            <div>{item.startDate}</div>
          </td>
          <td>{item.endDate}</td>
          <td>{item.payName}</td>
          <td>
            <span className="color_2">
              {this._CommaFormatted(item.price)}원
            </span>
          </td>
          <td>
            {/*item.autoBillIdx > 0 ? item.autoBillActive ? <span style={{cursor: 'pointer'}} onClick={this._expire}>해지신청</span> : '해지완료' : null */}
          </td>
        </tr>
      );
    });

    return list;
  };
  _CommaFormatted = (str) => {
    ////console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = '';
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = ',' + (parseInt(str) % 1000) + '00' + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = ',' + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ',0' + (parseInt(str) % 1000) + Money;
          else Money = ',00' + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };
  render() {
    // const { tabIndex } = this.props.childProps;
    const { dataList, con, auto, pageCount } = this.state;
    return (
      <Fragment>
        <div className="mypage_content">
          <div className="mypage_group">
            <h1>
              멤버십 내역<span>({con}건)</span>
              <div>
                {auto === 'Y' ? (
                  <a style={{ cursor: 'pointer' }} onClick={this._expire}>
                    정기결제 해지신청
                  </a>
                ) : null}
              </div>
            </h1>
            <div className="my_table_list">
              <table width="100%" border="0" cellSpacing="0" cellPadding="0">
                <colgroup>
                  <col width="10%" />
                  <col width="" />
                  <col width="10%" />
                  <col width="10%" />
                  <col width="11%" />
                  <col width="10%" />
                  <col width="10%" />
                </colgroup>
                <tbody>
                  <tr>
                    <th>결제일시</th>
                    <th>이용권 구분</th>
                    <th>시작일</th>
                    <th>종료일</th>
                    <th>결제수단</th>
                    <th>결제금액</th>
                    <th>이용해지</th>
                  </tr>
                  {dataList ? this._renderItem() : null}
                </tbody>
              </table>

              <div className="page_no new_page">
                <span style={{ cursor: 'pointer' }} onClick={this._onPrev}>
                  이전
                </span>
                {pageCount > 0 ? (
                  this._renderPage()
                ) : (
                  <span style={{ cursor: 'pointer' }} className="on">
                    1
                  </span>
                )}
                <span style={{ cursor: 'pointer' }} onClick={this._onNext}>
                  다음
                </span>
              </div>
            </div>
          </div>
        </div>
        {/*            
                <ToastContainer 
                    position="bottom-right"
                    hideProgressBar
                />
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(MyMemberShip));
